import { CategorySchema, ZodCreateCategorySchema, ZodUpdateCategorySchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type Category = CategorySchema;

export const getCategory = async (categoryId: string): Promise<Category> => {
  const response = await apiClient.get<{ category: Category }>(`/api/category/${categoryId}`);
  return response.data.category;
};

export const getCategories = async (): Promise<Category[]> => {
  const response = await apiClient.get<{ categories: Category[] }>("/api/category");
  return response.data.categories;
};

export const createCategory = async (categoryData: ZodCreateCategorySchema): Promise<Category> => {
  const response = await apiClient.post<{ category: Category }>("/api/category", categoryData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.category;
};

export const updateCategory = async (categoryData: ZodUpdateCategorySchema): Promise<Category> => {
  const response = await apiClient.put<{ category: Category }>(`/api/category/${categoryData.id}`, categoryData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.category;
};

export const deleteCategory = async (categoryId: string): Promise<{ message: string }> => {
  const response = await apiClient.delete<{ message: string }>(`/api/category/${categoryId}`);
  return response.data;
};

export default getCategory;
